document.addEventListener('DOMContentLoaded', function () {
  const toolbar = document.querySelector('.toolbar-item');
  const grid = document.querySelector('#product-grid');
  if (!toolbar || !grid) return;
  const icons = toolbar.querySelectorAll('.toolbar-icon');
  icons.forEach(icon => {
    icon.addEventListener('click', function () {
      icons.forEach(i => i.classList.remove('active'));
      this.classList.add('active');
      const gridClass = Array.from(this.classList)
        .find(cls => cls.startsWith('grid-'));
      if (!gridClass) return;
      const cols = gridClass.replace('grid-', '');
      grid.classList.forEach(cls => {
        if (cls.startsWith('grid--') && cls.endsWith('-col-desktop')) {
          grid.classList.remove(cls);
        }
      });
      grid.classList.add(`grid--${cols}-col-desktop`);
    });
  });
});
